import { useEffect, useState } from "react";

const useDeviceChart = (initialState = []) => {
  const [devicesChartList, setDevicesChartList] = useState(initialState);

  const onAdd = (item) => {
    setDevicesChartList((prevSt) => [
      ...prevSt,
      {
        index: new Date().getTime(),
        ...item,
      },
    ]);
  };

  const onUpdate = (index, item) => {
    setDevicesChartList((prevSt) =>
      prevSt?.map((deviceChart) =>
        deviceChart.index === index
          ? {
              ...deviceChart,
              ...item,
            }
          : deviceChart
      )
    );
  };

  const onAutoRefreshAll = (value) => {
    setDevicesChartList((prevSt) =>
      prevSt?.map((deviceChart) => ({
        ...deviceChart,
        autoRefresh: value,
      }))
    );
  };

  const onDelete = (index) => {
    setDevicesChartList((prevSt) =>
      prevSt?.filter((item) => item.index !== index)
    );
  };

  const onSort = (from, to) => {
    if (from !== to) {
      setDevicesChartList((prevStList) => {
        const newList = [...prevStList];
        const oldIndex = newList.findIndex((dev) => dev.index === from);
        const oldItem = newList[oldIndex];
        const newIndex = newList.findIndex((dev) => dev.index === to);

        newList?.splice(oldIndex, 1);
        newList?.splice(newIndex, 0, oldItem);

        return newList;
      });
    }
  };

  const onResize = (index, size) => {
    setDevicesChartList((prevSt) =>
      prevSt?.map((deviceChart) =>
        deviceChart.index === index
          ? {
              ...deviceChart,
              width: size.width,
              height: size.height,
            }
          : deviceChart
      )
    );
  };

  useEffect(() => {
    setDevicesChartList(initialState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [
    devicesChartList,
    setDevicesChartList,
    { onAdd, onUpdate, onDelete, onSort, onResize, onAutoRefreshAll },
  ];
};

export default useDeviceChart;
